import React from 'react';

const QwenOpenSource = () => (
  <article className="news-article-body">
    <p className="news-lead">
      Alibaba's <strong>Qwen</strong> series has become one of the most comprehensive open-source
      AI model families in the world — spanning dense and mixture-of-experts architectures,
      multimodal capabilities, and support for 201 languages. From Qwen3 in 2025 to Qwen3.5
      in early 2026, the series challenges the narrative that frontier AI requires proprietary
      closed systems.
    </p>

    <h2>Why Qwen Matters</h2>
    <p>
      Unlike OpenAI or Anthropic, Alibaba has chosen to release its most capable models as
      open weights on Hugging Face, GitHub, and ModelScope. This means any developer, researcher,
      or enterprise can download, fine-tune, and deploy Qwen models locally — without API costs
      or data leaving their infrastructure.
    </p>

    <h2>Key Model Milestones</h2>
    <div className="news-timeline">
      <div className="news-timeline-item">
        <span className="news-timeline-date">Qwen3 (2025)</span>
        <div>
          Eight models from 0.6B to 235B parameters (six dense + two MoE). Hybrid
          reasoning with switchable "think" and "non-think" modes. Trained on
          <strong> 36 trillion tokens</strong>.
        </div>
      </div>
      <div className="news-timeline-item">
        <span className="news-timeline-date">Qwen-Image (Aug 2025)</span>
        <div>
          20B parameter image generation model with exceptional text rendering and
          precise image editing. Released as open source.
        </div>
      </div>
      <div className="news-timeline-item">
        <span className="news-timeline-date">Qwen3.5-397B-A17B (Jan 2026)</span>
        <div>
          Natively multimodal foundation model with linear attention + sparse MoE
          architecture. Processes text, images, and up to 2 hours of video.
          Supports <strong>201 languages and dialects</strong>.
        </div>
      </div>
      <div className="news-timeline-item">
        <span className="news-timeline-date">Qwen3.5 Smaller Models (Feb–Mar 2026)</span>
        <div>
          122B, 35B, 27B, 9B, 4B, 2B, 0.8B — a full spectrum allowing deployment
          from edge devices to high-performance servers.
        </div>
      </div>
    </div>

    <h2>Technical Highlights</h2>
    <ul>
      <li>
        <strong>Sparse MoE + Linear Attention</strong>: Qwen3.5's architecture combines
        mixture-of-experts (only activating 17B of 397B params per inference) with linear
        attention for memory efficiency at long context lengths.
      </li>
      <li>
        <strong>GUI Agent Capabilities</strong>: Models can interact with device UIs and
        convert hand-drawn sketches into code — a meaningful step toward autonomous digital agents.
      </li>
      <li>
        <strong>Multilingual Depth</strong>: 201 languages including low-resource dialects
        often neglected by Western labs.
      </li>
    </ul>

    <h2>Competitive Position</h2>
    <p>
      Qwen3 and Qwen3.5 consistently rank at or near the top of open-source benchmarks,
      competing directly with closed-source models from OpenAI and Google. For the APAC region
      particularly, Qwen's multilingual depth and open availability make it the default
      open-source baseline.
    </p>

    <div className="news-insight-box">
      <h3>Key Takeaway</h3>
      <p>
        Qwen demonstrates that open-source AI and frontier performance are no longer mutually
        exclusive. As model weights become freely available, competitive advantage shifts to
        fine-tuning expertise, proprietary data, and deployment infrastructure.
      </p>
    </div>
  </article>
);

export default QwenOpenSource;
